<div class="uk-grid uk-grid-small mb-1" *ngIf="appUser$ | async as appUser">
    <div class="uk-width-large-1-2 mb-05">
        <b>Nombres y Apellidos</b><br />
        <span>{{ appUser.clubMember.name }} {{ appUser.clubMember.last_name }}</span>
    </div>
    <div class="uk-width-large-1-2 mb-05">
        <b>Número de Socio</b><br />
        <span>{{ appUser.memberNumber }}</span>
    </div>
    <div class="uk-width-large-1-2 mb-05">
        <b>Usuario</b><br />
        <span>{{ appUser.username }}</span>
    </div>
    <div class="uk-width-large-1-2 mb-05">
        <b>Total a Pagar</b><br />
        <span>{{ totalPayment | roMoney }}</span>
    </div>
</div>

<div class="uk-overflow-container tw-mb-8" style="max-height: 60vh; overflow-y: auto">
    <nz-table
        #paymentTable
        nzSize="small"
        [nzData]="paymentList"
        [nzShowPagination]="false"
        [nzLoading]="loadingPaymentList"
    >
        <thead>
            <tr>
                <th style="width: 50px"></th>
                <th style="width: 50px"></th>
                <th>Descripción</th>
                <th style="width: 50px" class="tw-text-right">Monto</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of paymentTable.data; let idx = index">
                <td class="tw-w-5">
                    <button nz-button nzType="primary" (click)="removeItem(item)" *ngIf="validationRemove(idx)">
                        <i nz-icon nzType="delete" nzTheme="outline"></i>
                    </button>
                </td>
                <td>
                    <div
                        *ngIf="item.siblingsIds?.length > 0"
                        [ngStyle]="{ backgroundColor: item.groupColor }"
                        class="tw-w-5 tw-h-5 tw-rounded-full"
                    ></div>
                </td>
                <td class="tw-uppercase">
                    {{ item.description }}
                </td>
                <td class="tw-text-right" style="width: 120px">
                    {{ item.amount | roMoney }}
                </td>
            </tr>
            <tr *ngFor="let commission of commissions" [style.background]="'antiquewhite'">
                <td class="tw-w-5"></td>
                <td></td>
                <td class="tw-uppercase">
                    <b>{{ commission.debt.description }}</b>
                </td>
                <td class="tw-text-right" style="width: 120px">
                    {{ commission.debt.amount | roMoney }}
                </td>
            </tr>
        </tbody>
        <tfoot>
            <tr>
                <td></td>
                <td></td>
                <td class="tw-text-right uk-text-medium uk-text-normal">Total</td>
                <td class="tw-text-right uk-text-large uk-text-normal">
                    <b>{{ totalPayment | roMoney }}</b>
                </td>
            </tr>
        </tfoot>
    </nz-table>
</div>

<div class="tw-flex tw-justify-end">
    <button nz-button nzType="primary" (click)="onReady.emit()" [disabled]="loadingPaymentList || !paymentList?.length">
        Siguiente Paso&nbsp;&nbsp;
        <i class="uk-icon uk-icon-arrow-right"></i>
    </button>
</div>
